import { createSelector } from 'reselect'
import { AppState } from 'Store'
import { ShortDataModel } from 'Models'

const selectReportsEntries = (state: AppState) => state.advertisement.report.reports_list.entries
const selectTotal = (state: AppState) => state.advertisement.report.reports_list.total_entries
const selectReport = (state: AppState) => state.advertisement.report.report
const selectCurrentParams = (state: AppState) => state.advertisement.report.requestParams
const selectOpenedReport = (state: AppState) => state.advertisement.report.openedReport
const selectDict = (state: AppState) => state.advertisement.organization.dict
const selectClientRole = createSelector(selectDict, (dict) => dict.invoices?.client_roles)
const selectContractorRole = createSelector(selectDict, (dict) => dict.invoices?.contractor_roles)
const selectAutomation = (state: AppState) => state.advertisement.report.autoReport
const selectAwaitAutomation = (state: AppState) => state.advertisement.report.awaitAutomation
const getClientRoles = (state): ShortDataModel[] =>
	state.advertisement.organization.dict?.client_roles_for_autogeneration
const getContractorRoles = (state): ShortDataModel[] =>
	state.advertisement.organization.dict?.contractor_roles_for_autogeneration

export const reportSelector = {
	selectReportsEntries,
	selectReport,
	selectCurrentParams,
	selectTotal,
	selectOpenedReport,
	selectClientRole,
	selectContractorRole,
	selectAutomation,
	selectAwaitAutomation,
	getClientRoles,
	getContractorRoles,
}
